import { z } from 'zod';

// WebSocket event types
export const wsEventTypeSchema = z.enum([
  'connection',
  'disconnection',
  'message',
  'notification',
  'user_status_change',
  'data_update',
]);

export type WsEventType = z.infer<typeof wsEventTypeSchema>;

// Base WebSocket message schema
export const wsMessageSchema = z.object({
  event: wsEventTypeSchema,
  data: z.unknown(),
  timestamp: z.string().datetime(),
  userId: z.string().uuid().optional(),
});

export type WsMessage = z.infer<typeof wsMessageSchema>;

// Notification WebSocket event
export const wsNotificationSchema = z.object({
  event: z.literal('notification'),
  data: z.object({
    id: z.string().uuid(),
    title: z.string(),
    message: z.string(),
    type: z.enum(['info', 'success', 'warning', 'error']),
    read: z.boolean(),
  }),
  timestamp: z.string().datetime(),
  userId: z.string().uuid(),
});

export type WsNotification = z.infer<typeof wsNotificationSchema>;

// User status change event
export const wsUserStatusSchema = z.object({
  event: z.literal('user_status_change'),
  data: z.object({
    userId: z.string().uuid(),
    status: z.enum(['online', 'offline', 'away']),
  }),
  timestamp: z.string().datetime(),
});

export type WsUserStatus = z.infer<typeof wsUserStatusSchema>;

// Generic message event
export const wsGenericMessageSchema = z.object({
  event: z.literal('message'),
  data: z.object({
    message: z.string(),
    senderId: z.string().uuid(),
    recipientId: z.string().uuid().optional(),
  }),
  timestamp: z.string().datetime(),
});

export type WsGenericMessage = z.infer<typeof wsGenericMessageSchema>;
